export default "__VITE_ASSET__DkuxgPoF__"